// Version compatibility for the NormalizedSqlModel. PRD § 2.4.

export type SchemaVersion = 'v1';
export const SCHEMA_VERSION: SchemaVersion = 'v1';

// Same major = compatible. SchemaVersion is currently the literal 'v1'.
// On a 'v2' bump, the grammar package exports both for one Jam release cycle
// (PRD § 2.4); during that window, downstream features pin via this helper.
export function isCompatibleSchemaVersion(requested: string): requested is SchemaVersion {
  return requested === SCHEMA_VERSION;
}
